import Axios from './axios_wrapper'

export function getCountries () {
  return Axios({
    url: `/countries`,
    method: 'GET'
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/countries.js
// module id = null
// module chunks = 